export default __webpack_public_path__ + "048f0ccd6ff81a825b79329f1effcd1c.png";